module.exports = __webpack_public_path__ + "img/shape_landing_comofunciona_7.cbad59ce.svg";